"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStyles = exports.getFontColorVariant = exports.getFontSize = void 0;
const building_blocks_ui_common_1 = require("@acko-tech/building-blocks.ui.common");
function getFontSize(size) {
    return building_blocks_ui_common_1.$fontSize[size || "normal"];
}
exports.getFontSize = getFontSize;
function getFontColorVariant(colorVariant) {
    let fontColor;
    switch (colorVariant) {
        case "primary":
            fontColor = building_blocks_ui_common_1.$primaryColors.normal;
            break;
        case "accent":
            fontColor = building_blocks_ui_common_1.$accentColors.normal;
            break;
        case "neutral":
            fontColor = building_blocks_ui_common_1.$neutralColors.normal;
            break;
        case "error":
            fontColor = building_blocks_ui_common_1.$error;
            break;
        case "hyperlink":
            fontColor = building_blocks_ui_common_1.$hyperlink;
            break;
        case "white":
            fontColor = building_blocks_ui_common_1.$white;
            break;
        case "light":
            fontColor = building_blocks_ui_common_1.$neutralColors.light;
            break;
        default:
            fontColor = building_blocks_ui_common_1.$neutralColors.dark;
    }
    return fontColor;
}
exports.getFontColorVariant = getFontColorVariant;
const getStyles = ({ fontSize, fontWeight, color }) => props => {
    return (0, building_blocks_ui_common_1.css) `
    font-weight: ${fontWeight};
    color: ${props && props.color ? props.color : color};
    margin: 0;
    ${fontSize && `font-size: ${fontSize}`};
    ${props && props.center && "text-align: center"};
  `;
};
exports.getStyles = getStyles;
//# sourceMappingURL=utils.js.map